import { createAction } from 'redux-actions';

const simplePayloadCreator = p => p;

export const setNutritionViewTime = createAction('SET_MEAL_TIME', simplePayloadCreator);
export const viewUpdatedAction = createAction('VIEW_UPDATED', simplePayloadCreator);

export const [ breakfast, lunch, dinner, night ] = ['breakfast', 'lunch', 'dinner', 'night'];

/*
export const setMealTime = ({
}) => (dispatch) => {
  dispatch(setViewDatesAction({ time }));
  if (selectedDates.length && user) {
    // assume selectedDates are sorted...
    const months = timeMonth.range(
      timeMonth(selectedDates[0]), selectedDates[selectedDates.length - 1],
    );
    const promises = [];
    months.forEach((month) => {
      const params = {
        startTime: month,
        endTime: timeMonth.offset(month, 1),
      };
      promises.push(dispatch(updateAllData({ params, user })));
    });
    Promise.all(promises).then(() => {
      dispatch(viewUpdatedAction({ selectBy, selectedDates, user }));
    });
  }
};
*/